import styled from 'styled-components';

export const Container = styled.div`
  border-top: 1px solid #e7e516;
  padding: 20px 0;
  margin: 0 20px 20px;
  display: flex;
  font-size: 0.8em;
  justify-content: space-between;

  .links {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    a {
      text-decoration: none;
      color: #f36620;
      &:hover {
        color: #000;
      }
    }

    & a:first-child {
      margin-bottom: 7px;
    }
  }
`;
